export function currencySymbol(currency?: string | null): string {
  switch (currency?.toUpperCase()) {
    case "NGN": return "₦";
    case "GBP": return "£";
    case "USD": return "$";
    case "EUR": return "€";
    default: return currency ? `${currency} ` : "";
  }
}

export function formatMoney(value: string | number | null | undefined, currency?: string | null): string {
  if (value === null || value === undefined || value === "") return "—";
  const number = Number(value);
  if (!Number.isFinite(number)) return "—";
  const symbol = currencySymbol(currency);
  if (Math.abs(number) > Number.MAX_SAFE_INTEGER) return `${symbol}${value}`.trim();
  return `${symbol}${number.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`.trim();
}
